import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, BarChart2 } from 'lucide-react';

const EmptyChartOverlay = ({ message, cta, ctaHref }) => (
  <div className="absolute inset-0 flex flex-col items-center justify-center gap-3 bg-white/80 backdrop-blur-[2px] rounded-b-xl z-10">
    <div className="h-10 w-10 rounded-full bg-ink-100 flex items-center justify-center">
      <BarChart2 className="h-5 w-5 text-ink-400" />
    </div>
    <p className="text-sm font-medium text-ink-600 text-center max-w-xs">{message}</p>
    {cta && ctaHref && (
      <Link to={ctaHref} className="btn btn-sm btn-secondary">
        {cta}
        <ArrowRight className="h-3 w-3" />
      </Link>
    )}
  </div>
);

export default EmptyChartOverlay;
